import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const HomeContainer = styled.div`
  display: flex;
  background: var(--bg);
  min-height: 100vh;
`;

export const MainContent = styled.main`
  flex: 1;
  background: #F7F9FC;
  width: 100%;
  margin-left: 280px; /* Largura do sidebar */
  
  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;

export const TopBar = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #E2E6EA;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 1024px) {
    padding: 12px 20px;
    gap: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    gap: 12px;
    flex-wrap: wrap;
  }
`;

export const TopBarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 12px;
    flex: 1;
    min-width: 0;
  }
`;

export const TopBarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const UserInfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  background: #F7F9FC;
  border-radius: 12px;
  border: 1px solid #E2E6EA;

  @media (max-width: 768px) {
    padding: 8px 12px;
    gap: 12px;
  }
`;

export const UserAvatarLarge = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #1264C7;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const UserName = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #1F1F1F;
  line-height: 1;
`;

export const UserEmail = styled.span`
  font-size: 13px;
  color: #5f6368;
  line-height: 1;
`;

export const EditProfileButton = styled.button`
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #E2E6EA;
  border-radius: 8px;
  color: #5f6368;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;

  &:hover {
    background: #F7F9FC;
    border-color: #1264C7;
    color: #1264C7;
  }

  .material-icons {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    padding: 8px;
    
    span:not(.material-icons) {
      display: none;
    }
  }
`;

export const IconButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #5f6368;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #F7F9FC;
  }

  .material-icons {
    font-size: 20px;
  }
`;

export const DashboardGrid = styled.div`
  padding: 32px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    padding: 20px;
    gap: 20px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const HeroCard = styled.div`
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 28px 32px;
  color: var(--ink);
  position: relative;
  overflow: hidden;
  animation: ${fadeIn} 0.6s ease;

  @media (max-width: 768px) {
    padding: 20px 16px;
    animation: none;
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
`;

export const HeroTitle = styled.h1`
  font-family: var(--font-sans);
  font-size: 34px;
  line-height: 40px;
  font-weight: 500;
  letter-spacing: -0.5px;
  margin: 0 0 8px 0;
  color: var(--ink);

  @media (max-width: 768px) {
    font-size: 26px;
    line-height: 32px;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 15px;
  line-height: 22px;
  color: var(--text-muted);
  margin: 0 0 20px 0;
  max-width: 640px;
`;

export const HeroMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid var(--line);
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const MetricItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-right: 1px solid #eef1f4;
  min-width: 0;

  &:last-child {
    border-right: 0;
  }

  @media (max-width: 1024px) {
    &:nth-child(2n) {
      border-right: 0;
    }
    &:nth-child(-n + 2) {
      border-bottom: 1px solid #eef1f4;
    }
  }
`;

export const MetricIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--brand-50);
  color: var(--brand-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .material-icons {
    font-size: 22px;
  }
`;

export const MetricValue = styled.div`
  font-family: var(--font-sans);
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.5px;
  color: var(--ink);
  line-height: 1.1;
`;

export const MetricLabel = styled.div`
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
`;

export const HeroActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  border: 0;
  background: var(--brand);
  color: #ffffff;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: var(--brand-700);
  }

  .material-icons {
    font-size: 20px;
  }
`;

export const SecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  border: 1px solid #dadce0;
  background: #ffffff;
  color: var(--brand-700);
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover {
    background: #f8fafd;
    border-color: #c2d7f5;
  }

  .material-icons {
    font-size: 20px;
  }
`;

export const QuickStatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  animation: ${slideUp} 0.6s ease 0.1s backwards;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    animation: none;
  }
`;

export const QuickStatCard = styled.div`
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 22px 24px;
  transition: border-color 0.15s, box-shadow 0.15s;
  cursor: pointer;

  &:hover {
    border-color: #c2d7f5;
    box-shadow: 0 4px 14px rgba(18, 100, 199, 0.08);
  }

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const StatNumber = styled.div`
  font-family: var(--font-sans);
  font-size: 28px;
  font-weight: 500;
  letter-spacing: -0.5px;
  color: var(--ink);
  margin-bottom: 4px;
  line-height: 1.1;
`;

export const StatText = styled.div`
  font-size: 13px;
  color: var(--text-muted);
`;

export const StatChange = styled.div<{ $positive?: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => (props.$positive ? "#1E8E3E" : "#D93025")};
  display: flex;
  align-items: center;
  gap: 4px;

  .material-icons {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 11px;
    
    .material-icons {
      font-size: 14px;
    }
  }
`;

export const MainSection = styled.div`
  animation: ${slideUp} 0.6s ease 0.2s backwards;

  @media (max-width: 768px) {
    animation: none;
  }
`;

export const TimelineActivitySection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  animation: ${slideUp} 0.6s ease 0.3s backwards;

  @media (max-width: 1024px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    animation: none;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const SectionTitle = styled.h2`
  font-family: var(--font-sans);
  font-size: 18px;
  font-weight: 500;
  color: var(--ink);
  margin: 0;
`;

export const SectionAction = styled.button`
  background: none;
  border: none;
  color: #1264C7;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: #EAF1FB;
  }

  .material-icons {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 10px;
    
    .material-icons {
      font-size: 16px;
    }
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  animation: ${slideUp} 0.6s ease 0.3s backwards;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    animation: none;
  }
`;

export const FeatureCard = styled.div`
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 22px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &:hover {
    border-color: #c2d7f5;
    box-shadow: 0 4px 14px rgba(18, 100, 199, 0.08);
  }
`;

export const FeatureIcon = styled.div<{ $color: string }>`
  width: 56px;
  height: 56px;
  background: ${(props) => props.$color};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
  margin-bottom: 20px;

  .material-icons {
    font-size: 28px;
  }

  @media (max-width: 1024px) {
    width: 48px;
    height: 48px;
    font-size: 24px;
    margin-bottom: 16px;
    
    .material-icons {
      font-size: 24px;
    }
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    font-size: 22px;
    border-radius: 10px;
    margin-bottom: 14px;
    
    .material-icons {
      font-size: 22px;
    }
  }
`;

export const FeatureTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1F1F1F;
  margin: 0 0 12px 0;

  @media (max-width: 1024px) {
    font-size: 17px;
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 8px;
  }
`;

export const FeatureDescription = styled.p`
  font-size: 14px;
  color: #5f6368;
  line-height: 1.6;
  margin: 0 0 16px 0;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 12px;
  }
`;

export const FeatureLink = styled.a`
  font-size: 14px;
  color: #1264C7;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;

  &:hover {
    gap: 8px;
  }

  .material-icons {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    
    .material-icons {
      font-size: 16px;
    }
  }
`;

export const TimelineCard = styled.div`
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 22px;
`;

export const TimelineHeader = styled.div`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const TimelineTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1F1F1F;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 17px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const TimelineList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const TimelineItem = styled.div`
  display: flex;
  gap: 16px;
  position: relative;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 19px;
    top: 40px;
    bottom: -20px;
    width: 2px;
    background: #E2E6EA;
  }

  @media (max-width: 768px) {
    gap: 12px;
    
    &:not(:last-child)::after {
      left: 17px;
      top: 36px;
      bottom: -16px;
    }
  }
`;

export const TimelineDot = styled.div<{ $color: string }>`
  width: 40px;
  height: 40px;
  background: ${(props) => props.$color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  .material-icons {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    
    .material-icons {
      font-size: 18px;
    }
  }
`;

export const TimelineContent = styled.div`
  flex: 1;
  padding-top: 4px;

  @media (max-width: 768px) {
    padding-top: 2px;
  }
`;

export const TimelineText = styled.p`
  font-size: 14px;
  color: #1F1F1F;
  font-weight: 500;
  margin: 0 0 4px 0;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 2px;
  }
`;

export const TimelineDate = styled.span`
  font-size: 13px;
  color: #5f6368;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

export const ActivityCard = styled.div`
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 22px;
`;

export const ActivityHeader = styled.div`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const ActivityTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1F1F1F;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 17px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ActivityGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 1024px) {
    gap: 12px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ActivityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #F7F9FC;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: #E2E6EA;
  }

  @media (max-width: 1024px) {
    padding: 14px;
    gap: 10px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 10px;
    border-radius: 6px;
  }
`;

export const ActivityIcon = styled.div<{ $color: string }>`
  width: 44px;
  height: 44px;
  background: ${(props) => props.$color};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;

  .material-icons {
    font-size: 22px;
  }

  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
    
    .material-icons {
      font-size: 20px;
    }
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    
    .material-icons {
      font-size: 18px;
    }
  }
`;

export const ActivityText = styled.div`
  flex: 1;
  min-width: 0;

  p {
    font-size: 14px;
    font-weight: 500;
    color: #1F1F1F;
    margin: 0 0 4px 0;
  }

  span {
    font-size: 13px;
    color: #5f6368;
  }

  @media (max-width: 768px) {
    p {
      font-size: 13px;
      margin-bottom: 2px;
    }

    span {
      font-size: 11px;
    }
  }
`;

export const SupportCard = styled.div`
  background: var(--brand-50);
  border: 1px solid var(--brand-50);
  border-radius: 16px;
  padding: 22px;
  display: flex;
  align-items: center;
  gap: 20px;
  color: var(--ink);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SupportIcon = styled.div`
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
  backdrop-filter: blur(10px);

  .material-icons {
    font-size: 32px;
  }

  @media (max-width: 1024px) {
    width: 56px;
    height: 56px;
    font-size: 28px;
    
    .material-icons {
      font-size: 28px;
    }
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    font-size: 24px;
    
    .material-icons {
      font-size: 24px;
    }
  }
`;

export const SupportContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SupportTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 8px 0;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 6px;
  }
`;

export const SupportText = styled.p`
  font-size: 14px;
  margin: 0;
  opacity: 0.95;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const SupportActions = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 1024px) {
    gap: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    gap: 10px;
  }
`;

export const SupportButton = styled.button<{ $variant?: string }>`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  ${(props) =>
    props.$variant === "primary"
      ? `
    background: #ffffff;
    color: #1E8E3E;
    border: none;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  `
      : `
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  `}

  .material-icons {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    padding: 10px 20px;
    font-size: 13px;
    
    .material-icons {
      font-size: 18px;
    }
  }

  @media (max-width: 768px) {
    flex: 1;
    justify-content: center;
    padding: 12px 16px;
    font-size: 13px;
    
    &:hover {
      ${(props) => props.$variant === "primary" ? "transform: none;" : "background: rgba(255, 255, 255, 0.2);"}
    }
  }
`;

export const FloatingWhatsAppButton = styled.button`
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #25d366 0%, #20ba5c 100%);
  border: none;
  color: white;
  font-size: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  transition: all 0.3s ease;
  z-index: 500;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 1024px) {
    bottom: 24px;
    right: 24px;
  }

  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    width: 56px;
    height: 56px;
    font-size: 26px;
  }
`;
